'use client'

import { Capacitor } from '@capacitor/core'
import { useEffect } from 'react'

export function PlatformDetector() {
  useEffect(() => {
    if (Capacitor.isNativePlatform()) {
      document.body.classList.add('capacitor-app')
      if (Capacitor.getPlatform() === 'ios') {
        document.body.classList.add('platform-ios')
      }
      if (Capacitor.getPlatform() === 'android') {
        document.body.classList.add('platform-android')
      }
    }
  }, [])

  return null
}
